var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"no-padding",attrs:{"fluid":""}},[_c('ManufacturingHistoricalLogbookList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }